import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTranslation } from 'react-i18next';

const SelectComponent = ({
  onValueChange,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onValueChange: (...event: any[]) => void;
}) => {
  const { t } = useTranslation();
  return (
    <Select onValueChange={onValueChange}>
      <SelectTrigger className='w-full'>
        <SelectValue placeholder={t('Select')} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>{t('Bank Account Types')}</SelectLabel>
          <SelectItem value='savings'>{t('Savings')}</SelectItem>
          <SelectItem value='checking'>{t('Checking')}</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default SelectComponent;
